export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 2,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 3,
				text: "The lecturer was not able to contribute to a productive learning and working atmosphere.",
			},
			{
				id: 4,
				text: "The lecturer provided the opportunity to discuss the content.",
			},
			{
				id: 5,
				text: "The lecturer was always well prepared.",
			},
			{
				id: 6,
				text: "The lecturer was knowledgeable with regard to the scope of the course.",
			},
			{
				id: 7,
				text: "The lecturer was able to make complicated subjects understandable.",
			},
			{
				id: 8,
				text: "The participants’ comprehension was important to the lecturer.",
			},
			{
				id: 9,
				text: "The lecturer contributed to a motivating learning atmosphere.",
			},
			{
				id: 10,
				text: "The learning objectives for the course were transparent.",
			},
			{
				id: 11,
				text: "The learning objectives were well defined.",
			},
			{
				id: 12,
				text: "The course was clearly structured.",
			},
			{
				id: 13,
				text: "The combination of the learning activities facilitated the learning objectives.",
			},
			{
				id: 14,
				text: "The combination of the learning activities was well defined.",
			},
			{
				id: 15,
				text: "I was interested in the subject of the course.",
			},
			{
				id: 16,
				text: "The topic of the course is relevant to my study program.",
			},
			{
				id: 17,
				text: "I feel that I learned a lot in this course.",
			},
			{
				id: 18,
				text: "The topic of the course is relevant for my professional goals.",
			},
			{
				id: 19,
				text: "The difficulty of the content was appropriate for the learning objectives.",
			},
			{
				id: 20,
				text: "The amount of the covered content was too much.",
			},
			{
				id: 21,
				text: "The pace of the course was appropriate for the level of my study program.",
			},
			{
				id: 22,
				text: "The amount of work required for the course was too time consuming for the number of ECTS.",
			},
			{
				id: 23,
				text: "The course was too difficult for me.",
			},
			{
				id: 24,
				text: "I did not feel challengend enough.",
			},
			{
				id: 25,
				text: "I found most of the topics covered too difficult.",
			},
			{
				id: 26,
				text: "The presentation style of oral presentations is appealing.",
			},
			{
				id: 27,
				text: "The presentations given by other participants were very informative.",
			},
			{
				id: 28,
				text: "The lecturer contributed helpful additional comments to the students’ seminar work.",
			},
			{
				id: 29,
				text: "The lecturer contributed to raising the quality of students’ seminar work.",
			},
			{
				id: 30,
				text: "The lecturer’s comments to the students’ seminar work were constructive.",
			},
			{
				id: 31,
				text: "The presented seminar work by students was of high quality.",
			},
			{
				id: 32,
				text: "The amount of seminar work (homework, teamwork, etc.) was adequate.",
			},
			{
				id: 33,
				text: "The exercises deepened my understanding of abstract contents.",
			},
			{
				id: 34,
				text: "The seminar work clarified the relevance of the course ́s content.",
			},
			{
				id: 35,
				text: "The seminar work made me think the concepts through.",
			},
			{
				id: 36,
				text: "The seminar work inspired me to critically reflect the content we discussed.",
			},
			{
				id: 37,
				text: "The seminar work motivated me to further occupy myself with the contents of the course.",
			},
			{
				id: 38,
				text: "The seminar work offered practical experience in terms of project work.",
			},
			{
				id: 39,
				text: "The seminar work provided opportunities to learn from the other students.",
			},
			{
				id: 40,
				text: "There was ample opportunity for interaction with the lecturer through the online tools.",
			},
			{
				id: 41,
				text: "There was ample opportunity for interaction with the other students through the online tools.",
			},
			{
				id: 42,
				text: "The online appointments were well organized.",
			},
			{
				id: 43,
				text: "The online materials (e.g. texts, quizzes, videos, etc.) contributed significantly to the understanding of the learning content.",
			},
			{
				id: 44,
				text: "The possibilities of digital teaching beyond traditional teaching (discussion forums, interactive assignments, etc.) were well used.",
			},
			{
				id: 45,
				text: "Overall, the digital elements of the event were good.",
			},
			{
				id: 46,
				text: "The course is an example of good digital education.",
			},
			{
				id: 47,
				text: "Overall, this was a good course.",
			},
			{
				id: 48,
				text: "I learned a lot in this course.",
			},
			{
				id: 49,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 50,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 51,
				text: "Further remarks regarding the course (praise/criticism)",
			},
		],
	},
	{
		type: "age",
		id: 3,
		items: [
			{
				id: 52,
				text: "Age: ",
			},
		],
	},
];
